import { trpc } from '@/shared/api/trpc';

export const useForcePasswordReset = () =>
  trpc.accounts.forcePasswordReset.useMutation();
